/**
 * @auth 赖传峰
 * @date 2024/6/3
 */
import { SupportLocale } from '~/types/enum'

// @ts-expect-error 未自动识别的
export default defineI18nLocale(async (locale: SupportLocale) => (await import(`../locale/${locale}.json`)).default)
